import { motion } from "framer-motion";
import KeyButton from "@/components/KeyButton";

const links = [
  { label: "WORK", href: "#work", testid: "nav-link-work" },
  { label: "PACKAGES", href: "#packages", testid: "nav-link-packages" },
  { label: "CONTACT", href: "#contact", testid: "nav-link-contact" },
];

export const scrollToSection = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Nav() {
  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed inset-x-0 top-0 z-40 border-b border-[#0D0D0D]/10 bg-[#F4F3EF]/85 backdrop-blur-md"
    >
      <div className="relative mx-auto flex max-w-[1400px] items-center justify-end px-6 py-4 sm:px-10">
        <a
          data-testid="nav-logo-link"
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#top");
          }}
          className="absolute left-1/2 block -translate-x-1/2"
        >
          <img
            src="/logo-black.png"
            alt="Leevé Media"
            className="h-4 w-auto sm:h-5"
          />
        </a>
        <nav className="flex items-center gap-5 sm:gap-9">
          <span className="hidden items-center gap-9 sm:flex">
            {links.map((l) => (
              <a
                key={l.href}
                data-testid={l.testid}
                href={l.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(l.href);
                }}
                className="font-mono-label text-[10px] tracking-[0.25em] text-[#0D0D0D] transition-colors duration-300 hover:text-[#8C8B85] sm:text-xs"
              >
                {l.label}
              </a>
            ))}
          </span>
          <KeyButton
            testid="nav-cta-button"
            compact
            onClick={() => scrollToSection("#contact")}
          >
            INQUIRE
          </KeyButton>
        </nav>
      </div>
    </motion.header>
  );
}
